/*
Author: Vaishnavi
Date: 26/11/2019
Issue Description: Removed header
*/
/*
Author: Shivakumar
Date: 7/2/2020
Issue Description: [QA Instance] - [Payroll preferences]-Navigation issue-When click on Payroll preferences ,it should start from Payroll settings
search: PL-2346
*/
<template>
  <div>
    <tl-header type="h1">
      <div>Payroll Preferences</div>
      <template slot="icon">
        <div class="showIntro" @click="goToIntro">
          <img src="@/assets/questionmark.png" />
        </div>
      </template>
    </tl-header>
    <tl-stepper :heading="items" :current="current" />
    <div>
      <component :is="activeComponent" v-on:stepNum="setComponent" />
    </div>
  </div>
</template>


<script>
import TlStepper from "@/components/stepper/TlStepper.vue";
import PayrollCycle from "./PayrollCycle.vue";
import PayrollComputation from "./PayrollComputation.vue";
import SalaryComponents from "./SalaryComponents.vue";
import SalaryStructure from "./SalaryStructure.vue";
import PerquisiteComponents from "./perquisites.vue";
import Payslips from "./Payslips.vue";

export default {
  name: "Preferences",
  components: {
    TlStepper,
    PayrollCycle,
    PayrollComputation,
    SalaryComponents,
    SalaryStructure,
    Payslips
  },
  data() {
    return {
      activeComponent: "PayrollCycle",
      activeIndex: 0,
      current: 0,
      items: [
        "Payroll Settings",
        "Payroll Computation",
        "Salary Components",
        "Salary Structures",
        "Perquisite Components",
        "Payslips"
      ],
      components: [
        PayrollCycle,
        PayrollComputation,
        SalaryComponents,
        SalaryStructure,
        PerquisiteComponents,
        Payslips
      ]
    };
  },
  activated() {
    //PL-2346, PL-2672, PL-2673
    if (this.activeIndex != 2 && this.activeIndex != 3 && this.activeIndex != 4) {
      this.activeComponent = this.components[0];
      this.setComponent(0);
    }
    //PL-2346, PL-2672, PL-2673
  },

  // mounted() {
  //   if(false){
  //     this.items.splice(4,1);
  //     this.components.splice(4,1)
  //   }
  // },

  destroyed() {
    this.activeIndex = 0;
    this.activeComponent = this.components[0];
    this.setComponent(0);
  },

  beforeDestroy() {
    this.activeIndex = 0;
    this.activeComponent = this.components[0];
    this.setComponent(0);
  },
  //   watch: {
  //   '$route' (to, from) {
  //         this.__mounted();
  //   }
  // },
  watch: {
    value: function(v) {
      this.mounted();
    }
  },
  methods: {
    goToIntro() {
      this.$emit("displayIntro");
    },

    setComponent(index) {
      this.current = index;
      this.activeComponent = this.components[index];
      if (index < this.items.length) {
        // this.changeStatus(index);
        // this.activeComponent = this.items[index].component;
        this.activeIndex = index;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.activeIndex = vm.$route.params["activeIndex"];
      vm.setComponent(vm.activeIndex);
    });
  }
};
</script>
<style lang="scss" scoped>
.showIntro {
  cursor: pointer;
}
%navIcon {
  width: 18px;
  height: 18px;
  background-color: #d8d8d8;
  border-radius: 50%;
}
.flex {
  display: flex;
  position: relative;
}
.stepper-item {
  flex: 1;
}
%line {
  width: 200px;
  top: 30px;
  height: 1px;
  position: absolute;
  border-top: 1px solid #d8d8d8;
}
%label {
  font-size: 14px;
  font-family: Montserrat;
}
@mixin stepper-style($color) {
  .navIcon {
    @extend %navIcon;
  }
  .line {
    @extend %line;
    z-index: -1;
  }
  .label {
    @extend %label;
    color: $color;
  }
}
.pending {
  @include stepper-style(#303030);
}
.active {
  @include stepper-style(#050505);
  .navIcon {
    background-color: #34c0be;
  }
  .label {
    font-weight: bold;
  }
}
.complete {
  @include stepper-style(#34c0be);
  .navIcon {
    background-color: #34c0be;
  }
  .line {
    border-color: #34c0be;
  }
}
</style>
